import { render, staticRenderFns } from "./InvoiceDescriptionTable.vue?vue&type=template&id=68f885a8&"
import script from "./InvoiceDescriptionTable.vue?vue&type=script&lang=js&"
export * from "./InvoiceDescriptionTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports